import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Icon } from '@src-common/view/components/Icon';

import s from './styles.module.css';

interface IProps {
  onClick: () => void;
  /** The document is on its way: a second click would fetch it twice. */
  isLoading?: boolean;
  className?: string;
}

const AgencyAgreementConfirmation = ({ onClick, isLoading = false, className }: IProps) => (
  <div className={cn(s.root, className)}>
    <button type="button" onClick={onClick} disabled={isLoading} className={s.button}>
      <FormattedMessage
        defaultMessage="Подтверждение агентского договора"
        id="/mYT/4"
        description="RU only: Agency agreement confirmation"
      />
      <Icon icon="chevron-to-end" />
    </button>
  </div>
);

export { AgencyAgreementConfirmation };
